import { useTranslate } from "@similarweb/i18n-provider";
import { colorsPalettes } from "@similarweb/styles";
import { Stack, Text } from "@similarweb/ui-components/foundations";

import { useLowQuotaBannerManagement } from "../../../hooks/useLowQuotaBannerManagement";
import { quotaKeys } from "../../../utils/i18n";

export const DataCreditsHighUsageTooltip = () => {
    const { translate } = useTranslate();
    const { lowCreditsBannerConfigs } = useLowQuotaBannerManagement();
    const showActionLink = lowCreditsBannerConfigs.onClick && lowCreditsBannerConfigs.buttonTextKey;

    return (
        <Stack
            width="230px"
            gap="4px"
            data-automation="quota-data-credits-tooltip-high-usage"
        >
            <Text
                fontVariant="listItem4"
                color={colorsPalettes.bluegrey[100]}
            >
                {translate(quotaKeys.dataCreditsExtendedOver90Title)}
            </Text>
            <Text
                fontVariant="tooltip"
                color={colorsPalettes.bluegrey[100]}
            >
                {translate(quotaKeys.dataCreditsExtendedOver90Description)}
            </Text>
            {showActionLink ? (
                <Text
                    as="a"
                    onClick={lowCreditsBannerConfigs.onClick}
                    fontVariant="tooltip"
                    color={colorsPalettes.blue[300]}
                    cursor="pointer"
                    data-automation="quota-data-credits-tooltip-addon-link"
                >
                    {translate(lowCreditsBannerConfigs.buttonTextKey)}
                </Text>
            ) : null}
        </Stack>
    );
};
